// extracted by mini-css-extract-plugin
export var labelWrapper = "_fd-0";